import { TEXTS as STREAM_TEXTS } from 'application/pages/texts';

import { DeviceTypes } from 'domain/api/graphql/generated';

import { HintPlacement } from '@zvuk-b2b/react-uikit/ui/Popper';

import { TEXTS } from './texts';
import { DEVICE_TEXTS } from './consts';

export const getStreamDescription = (streamTitle?: string, showVideoStream: boolean = false) => {
  const title = streamTitle || STREAM_TEXTS.MODAL_BIND_STREAM_NOT_BIND;
  const header = showVideoStream ? STREAM_TEXTS.MODAL_BIND_VIDEO_STREAM_BIND : STREAM_TEXTS.MODAL_BIND_STREAM_BIND;

  return `${header}: ${title}`;
};

export const getPlayerDescription = (
  deviceType?: DeviceTypes,
  showVideoStreamData: boolean = false,
  isVideoSupport: boolean = false
) => {
  if (!deviceType) {
    return TEXTS.NO_DEVICE;
  }

  const deviceText = DEVICE_TEXTS[deviceType];

  if (showVideoStreamData) {
    return isVideoSupport ? deviceText : `${deviceText}, ${TEXTS.NO_VIDEO}`;
  }

  return deviceText;
};

export const getPopperPlacement = (isDesktop: boolean, hintIconNearSelector: boolean) => {
  if (hintIconNearSelector) {
    return HintPlacement.PLACEMENT_RIGHT;
  }

  if (isDesktop) {
    return HintPlacement.PLACEMENT_RIGHT_END;
  }

  return HintPlacement.PLACEMENT_BOTTOM;
};
